module.exports = __webpack_public_path__ + "static/media/8.question.460b11d0.mp4";